import React from 'react';
export function Reserve() {
  return <section id="reserve" className="bg-[#EFE8DC] border-y border-[#8c6f47]/40" data-id="element-52" data-mp="3k4fja8sjg69i">
      <div className="px-6 md:px-12 lg:px-20 max-w-[88rem] mx-auto py-28 md:py-36" data-id="element-53" data-mp="23fx0y9rtklal">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8" data-id="element-54" data-mp="1yepovyin8zy4">
          <div className="md:col-span-3" data-id="element-55" data-mp="1tgegztbwszij">
            <div className="label accent" data-id="element-56" data-mp="1tfcxd0gtv4p7">The Flagship</div>
          </div>
          <div className="md:col-span-8 md:col-start-5" data-id="element-57" data-mp="1ohuvtv553rr8">
            <a href="https://reserve.verawellnessco.com" className="group inline-block" data-id="element-58" data-mp="1ojfr5mza3eq5">
              <span className="flex items-baseline gap-4" data-id="element-59" data-mp="1forirnyepgx4">
                <h2 className="text-4xl md:text-6xl border-b border-transparent group-hover:border-[#8c6f47] transition-colors duration-300 pb-1" data-id="element-60" data-mp="1fp9dgg5f7n2x">
                  Vera Reserve
                </h2>
                <span aria-hidden="true" className="font-serif text-3xl md:text-5xl text-[#8c6f47] group-hover:translate-x-1 transition-all duration-300" data-id="element-61" data-mp="15q1zbqqv3oer">
                  →
                </span>
              </span>
              <span className="label text-[#8c6f47] mt-4 block" data-id="element-62" data-mp="3c3ji3pkjxf0i">
                Enter the private advisory
              </span>
            </a>
            <p className="mt-10 font-sans font-light text-lg md:text-xl text-graphite/80 leading-relaxed max-w-2xl" data-id="element-63" data-mp="2xbr71prsin4l">
              Full concierge management of training, nutrition, travel, and
              recovery, integrated with your assistant and your life. Eight
              seats, held by application. Three are open.
            </p>
          </div>
        </div>
      </div>
    </section>;
}